import { actions } from './actions'

const initialState = {
  productPixel: null,
  loading: false,
  popupSuccess: false
}

export const reducerProductPixel = (state = initialState, action) => {
  switch (action.type) {
    case actions.set_state:
      return { ...state, ...action.payload }
    default:
      return state
  }
}
